import React from 'react';

const baseInputStyles = "px-4 py-2.5 h-11 w-full border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200 text-sm transition-colors";
const moneyInputStyles = "pl-8 pr-4 py-2.5 h-11 w-full border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200 text-sm transition-colors";

export default function AdditionalInfo({
  websiteLink,
  externalId,
  price,
  ownerPrice,
  payout,
  integratedWithStreamline,
  onInputChange,
  onNumberInputScroll,
}) {
  return (
    <>
      <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Additional Information</h3>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Website Link</label>
            <input
              type="text"
              name="websiteLink"
              value={websiteLink || ''}
              onChange={onInputChange}
              className={baseInputStyles}
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">External ID</label>
            <input
              type="text"
              name="externalId"
              value={externalId || ''}
              onChange={onInputChange}
              className={baseInputStyles}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Price</label>
            <div className="relative">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <input
                type="number"
                step="0.01"
                name="price"
                value={price || ''}
                onChange={onInputChange}
                onWheel={onNumberInputScroll}
                className={moneyInputStyles}
              />
            </div>
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Owner Price</label>
            <div className="relative">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <input
                type="number"
                step="0.01"
                name="ownerPrice"
                value={ownerPrice || ''}
                onChange={onInputChange}
                onWheel={onNumberInputScroll}
                className={moneyInputStyles}
              />
            </div>
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Payout</label>
            <div className="relative">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <input
                type="number"
                step="0.01"
                name="payout"
                value={payout || ''}
                onChange={onInputChange}
                onWheel={onNumberInputScroll}
                className={moneyInputStyles}
              />
            </div>
          </div>
        </div>

        <div className="pt-6">
          <div className="flex items-center space-x-3">
            <input
              type="checkbox"
              id="integratedWithStreamline"
              name="integratedWithStreamline"
              checked={integratedWithStreamline || false}
              onChange={onInputChange}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <label htmlFor="integratedWithStreamline" className="text-sm font-medium text-gray-700">
              Integrated with Streamline
              {integratedWithStreamline && (
                <span className="ml-2 text-xs text-gray-500">(Some fields will be read-only)</span>
              )}
            </label>
          </div>
        </div>
      </div>
    </>
  );
}
